module.exports = __webpack_public_path__ + "img/rvdsb-5@small.cf499944.png";